export default __webpack_public_path__ + "static/media/026-mountain.53874303.svg";